import { errorLogService } from '../services/errorLogService';

/**
 * Inicializa o sistema de logging de erros do frontend
 * Sobrescreve console.error e capture global errors
 */
export function initializeErrorLogging() {
  // ============================================
  // 1. INTERCEPTAR console.error()
  // ============================================
  const originalError = console.error;
  console.error = function (...args) {
    // Chama original primeiro (mantém comportamento esperado)
    originalError.apply(console, args);

    // Envia para backend (fire-and-forget, não bloqueia)
    if (args.length > 0) {
      const error = args[0];
      // Executa de forma assíncrona sem aguardar
      errorLogService.logError(error).catch(() => {
        // Silencia qualquer erro
      });
    }
  };

  // ============================================
  // 2. CAPTURAR ERROS GLOBAIS NÃO-TRATADOS
  // ============================================
  window.addEventListener('error', (event) => {
    // Já capturado por console.error em alguns casos
    // Mas garante que exceções não-tratadas sejam logadas
    errorLogService.logError(event.error || event.message).catch(() => {});
  });

  // ============================================
  // 3. CAPTURAR PROMISE REJECTIONS NÃO-TRATADAS
  // ============================================
  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason instanceof Error
      ? event.reason
      : new Error(String(event.reason));
    errorLogService.logError(error).catch(() => {});
  });

  console.log('[ErrorLogging] Sistema inicializado com sucesso');
}
